"use client";

import { useTranslations } from "next-intl";
import ImageCarousel, { type CarouselImage } from "@/components/home/ImageCarousel";

// Add/remove entries here to change what shows in the massage room carousel.
const MASSAGE_ROOM_IMAGES: CarouselImage[] = [
  { src: "/img/masazna_soba2.webp", alt: "Saiyan Gym masažna soba — topla atmosfera i stol za masažu" },
];

export default function MassageRoomSection() {
  const t = useTranslations("MassageRoom");
  const categories = t.raw("categories") as string[];

  return (
    <section className="mx-auto max-w-6xl px-6 py-16 sm:px-8 lg:px-10">
      <div className="flex flex-col gap-10 lg:flex-row lg:items-center lg:gap-16">

        {/* Left — text */}
        <div className="flex flex-col gap-6 lg:w-[45%]">

          {/* Heading */}
          <h2 className="text-4xl font-black leading-tight tracking-tight text-[#18181b] sm:text-5xl">
            {t("heading")}
          </h2>

          {/* Category pills */}
          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <span
                key={cat}
                className="rounded-full border border-[#E4E4E7] bg-white px-4 py-1.5 text-sm font-medium text-[#18181b]"
              >
                {cat}
              </span>
            ))}
          </div>

          {/* Paragraph */}
          <p className="text-base leading-relaxed text-[#71717a]">
            {t("paragraph")}
          </p>

        </div>

        {/* Right — image */}
        <div className="w-full flex-shrink-0 lg:w-[55%]">
          <ImageCarousel images={MASSAGE_ROOM_IMAGES} className="aspect-[4/3]" />
        </div>

      </div>
    </section>
  );
}
